/**
 * INV-12 TYPE-LEVEL EXHAUSTIVENESS.
 *
 * Put this in the `default` branch of every switch over a closed union (field
 * types, filter operators, node kinds). Adding a union member then becomes a
 * compile error at every switch that forgot to handle it.
 */
export function assertNever(value: never, context: string): never {
  throw new Error(`${context}: unhandled variant ${JSON.stringify(value)}`);
}
